<template>
    <div class="sidebar seismic">
        <router-link v-if="design && design.id" :to="{ name: 'submittal-brace-summary', params: {id: design.id}}">
            <h5 class="summary">Seismic Summary</h5>
        </router-link>

        <h5 class="summary" v-else>Seismic Summary</h5>
        <div>
            <div>
                <router-link v-if="design && design.id" :to="{ name: 'submittal-setup', params: {id: design.id}}">
                    <h5><span>1</span> Seismic Design Setup</i></h5>
                </router-link>
                <h5 class="setup" v-else><span>1</span> Seismic Design Setup</h5>

                <ul v-if="design">
                    <li v-if="design.name">
                        <span>Design Name:</span>
                        <strong v-text="design.name"></strong>
                    </li>
                    <li v-if="standardName">
                        <span>Standard:</span>
                        <strong v-text="standardName"></strong>
                    </li>
                    <li v-if="agencyName">
                        <span>Agency:</span>
                        <strong v-text="agencyName"></strong>
                    </li>
                    <li v-else-if="!agencyName && (design && design.id)">
                        <span>Agency:</span>
                        <strong class="required">AGENCY SELECTION REQUIRED</strong>
                    </li>
                    <li v-if="projectUnits">
                        <span>Project Units:</span>
                        <strong v-text="projectUnits"></strong>
                    </li>
                </ul>
            </div>
            <div>
                <router-link v-if="hasBrace" :to="{ name: 'submittal-brace-identify', params: {designId: design.id, id: brace.id }}">
                    <h5><span>2</span> Finding Seismic Coefficient (Cp)</i></h5>
                </router-link>
                <h5 class="identify" v-else><span>2</span> Finding Seismic Coefficient (Cp)</h5>

                <ul v-if="hasBrace">
                    <li v-if="brace.name">
                        <span>Brace Name:</span>
                        <strong v-text="brace.name"></strong>
                    </li>
                    <li v-if="brace.drawingReference">
                        <span>Drawing Reference:</span>
                        <strong v-text="brace.drawingReference"></strong>
                    </li>
                    <li v-if="brace.cp">
                        <span>Seismic Coefficient:</span>
                        <strong v-text="brace.cp"></strong>
                    </li>
                </ul>
            </div>
            <div>
                <router-link v-if="showLinks" :to="{ name: 'submittal-brace-piping', params: {designId: design.id, id: brace.id }}">
                    <h5><span>3</span> Define Brace Type and Piping System</i></h5>
                </router-link>
                <h5 class="system" v-else><span>3</span> Define Brace Type and Piping System</h5>

                <ul v-if="showLinks">
                    <li>
                        <span>Seismic Design Load:</span>
                        <strong v-text="lbfOrKn(seismicDesignLoad, true, design.useMetric)"></strong>
                    </li>
                </ul>
            </div>
            <div>
                <router-link v-if="showLinks" :to="{ name: 'submittal-brace-attachment', params: {designId: design.id, id: brace.id }}">
                    <h5><span>4</span> Define Structure and Pipe Attachments</i></h5>
                </router-link>
                <h5 class="attachment" v-else><span>4</span> Define Structure and Pipe Attachments</h5>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'sidebar',

        props: [
            'design',
            'brace',
        ],
        computed: {
            ...mapGetters({
                standardName: 'submittalStandards/standardName',
                seismicDesignLoad: 'submittalSystem/zoiSeismicDesignLoad',
            }),
            agencyName() {
                if (this.design.agency === 'fm-approved') {
                    return 'FM Approved';
                }
                if (this.design.agency === 'ul-listed') {
                    return 'UL Listed';
                }
                return '';
            },
            hasBrace() {
                if (this.design && this.brace) {
                    return true;
                }

                return false;
            },
            showLinks() {
                if (this.design && this.brace && this.seismicDesignLoad) {
                    return true;
                }

                return false;
            },
            projectUnits() {
                switch (this.design.useMetric) {
                    case 1:
                    case '1':
                        return 'Metric (m, mm, kg, kN, MPa)';
                    case 0:
                    case '0':
                        return 'Imperial (ft, in, lbs, lbf, psi)';
                    default:
                        return null;
                }
            }
        },
        mounted() {
            // var $height = $('.sidebar').outerHeight() + 200;
            // $('aside.primary .sidebar').fix({
            //     until: 'footer.primary',
            //     stopEarly: $height
            // });
        }
    }
</script>
